import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ChatHeader from "@/components/Dialogues/Chat/ChatHeader.vue";
import ChatContent from "@/components/Dialogues/Chat/ChatContent.vue";
import { isCompactMode } from "@/data/pubilc";

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatBase',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base", {
      'chat-base-compact': _unref(isCompactMode),
    }])
  }, [
    _createVNode(ChatHeader),
    _createVNode(ChatContent, { class: "flex1" })
  ], 2))
}
}

})